import React from 'react'
import OnePagerBarChart from '../../../components/OnePagerBarChart';

const CompositionWalletIgr = ({ t, sectors, dataSize, selectColors }) => {
    return (
        <div className="compositionWallet">
            <div className='bar-chart-title'>
                <h3 className="chart-title">{t('one_pager_report.portfolio_composition')}</h3>
                <p>{t('one_pager_report.approved_amount_projects')}</p>
            </div>

            <div className="content-one-page-barchart">
                {sectors.map((item, index) => {
                    return (
                        <OnePagerBarChart
                            key={index}
                            bgColors={selectColors(sectors)[index]}
                            barChartData={item}
                            size={dataSize}
                        />
                    );
                })}
            </div>
        </div>
    )
}

export default CompositionWalletIgr